// import React from 'react';
// import { Container, Card, Row, Col } from 'react-bootstrap';
// import axios from 'axios';
// import { useEffect, useState } from 'react';
// import NavigationBar from '../../Components/NavigationBar';
// import "./AccessPage.css"

// const ProfilePage = ({ user }) => {
//   // Dummy data if no props provided
//   const profile = user || {
//     name: 'John Doe',
//     email: 'john.doe@example.com',
//     role: 'Administrator',
//   };

//   return (
//     <div>
//         <NavigationBar />
//     <Container className="mt-5">
//       <Row className="justify-content-center">
//         <Col md={6}>
//           <Card className="shadow-lg">
//             <Card.Body>
//               <Card.Title className="text-center mb-4">Profile Details</Card.Title>
//               <Row>
//                 <Col xs={4}><strong>Name:</strong></Col>
//                 <Col xs={8}>{profile.name}</Col>
//               </Row>
//               <hr />
//               <Row>
//                 <Col xs={4}><strong>Email:</strong></Col>
//                 <Col xs={8}>{profile.email}</Col>
//               </Row>
//               <hr />
//               <Row>
//                 <Col xs={4}><strong>Role:</strong></Col>
//                 <Col xs={8}>{profile.role}</Col>
//               </Row>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//     </div>
//   );
// };

// export default ProfilePage;

// import React, { useEffect } from 'react';
// import { Container, Card, Row, Col, Image } from 'react-bootstrap';
// import './AccessPage.css'; // optional for extra styling
// import defaultAvatar from '../../Assets/ProfileAvatar.png'; // replace with actual image if available
// import axios from 'axios';
// import './AccessPage.css';
// import NavigationBar from '../../Components/NavigationBar';
// import { useState } from 'react';


// const ProfilePage = ({ user }) => {
// const [profile, setProfile] = useState(null);
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
 
//  useEffect(() => {
//   fetch(`${API_BASE_URL}/userdetails`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ user_id: localStorage.getItem('user_id') }), // or get from context/session
//   })
//     .then((res) => res.json())
//     .then((data) => {
//       if (data.status) {
//         setProfile({
//           name: data.user_name,
//           email: data.email,
//           role: data.user_role,
//           avatar: defaultAvatar,
//         });
//       }
//     })
//     .catch((err) => console.error("Error fetching user details:", err));
// }, []);

//   return (
//     <div>
//     <NavigationBar />
//     <Container className="d-flex justify-content-center align-items-center min-vh-100">
//       <Card className="profile-card shadow-lg">
//         <Card.Body>
//           <div className="text-center mb-4">
//             <Image src={profile.avatar} roundedCircle className="profile-avatar" />
//             <Card.Title className="mt-3 fs-3">{profile.name}</Card.Title>
//             <Card.Subtitle className="text-muted">{profile.role}</Card.Subtitle>
//           </div>
//           <hr />

//           <Row className="mb-3">
//             <Col xs={4} className="fw-bold text-end">Name:</Col>
//             <Col xs={8}>{profile.name}</Col>
//           </Row>

//           <Row className="mb-3">
//             <Col xs={4} className="fw-bold text-end">Email:</Col>
//             <Col xs={8}>{profile.email}</Col>
//           </Row>

//           <Row>
//             <Col xs={4} className="fw-bold text-end">Role:</Col>
//             <Col xs={8}>{profile.role}</Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </Container>
//     </div>
//   );
// };

// export default ProfilePage;


import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import './AccessPage.css'; // Optional for extra styles
import defaultAvatar from '../../Assets/ProfileAvatar.png'; // Replace with your own image
import NavigationBar from '../../Components/NavigationBar';
import "./AccessPage.css"; // Optional for extra styling

const ProfilePage = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = localStorage.getItem('user_id'); // Must be set during login

    if (!userId) {
      console.error("User ID not found in localStorage");
      setLoading(false);
      return;
    }

    fetch(`${API_BASE_URL}/userdetails`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setProfile({
            name: data.user_name,
            email: data.email,
            role: data.user_role,
            avatar: defaultAvatar,
          });
        } else {
          console.error(data.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching user details:", err);
        setLoading(false);
      });
  }, [API_BASE_URL]);

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" role="status" />
      </Container>
    );
  }

  if (!profile) {
    return (
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <p>Unable to load profile data.</p>
      </Container>
    );
  }

  return (
    <div>
      <NavigationBar />
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Card className="profile-card shadow-lg p-2" style={{ width: '100%', maxWidth: '400px' }}>
          <Card.Body>
            <div className="text-center mb-4">
              <Image src={profile.avatar} roundedCircle className="mb-3" width="80" height="80" />
              <Card.Title className="fs-3">{profile.name}</Card.Title>
              <Card.Subtitle className="text-muted">{profile.role}</Card.Subtitle>
            </div>
            <hr />
            <Row className="mb-3">
              <Col xs={4} className="fw-bold text-end">Name:</Col>
              <Col xs={8}>{profile.name}</Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4} className="fw-bold text-end">Email:</Col>
              <Col xs={8}>{profile.email}</Col>
            </Row>
            <Row>
              <Col xs={4} className="fw-bold text-end">Role:</Col>
              <Col xs={8}>{profile.role}</Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default ProfilePage;
